import React from "react"
import styled from "styled-components"


const SwapTitle = styled.p`
	margin-left: 2.5rem;
	margin-bottom: 1rem;
	margin-top: 1rem;
	font-size: 1.5rem;

	/* Tablets */
	@media (max-width: 1400px) {
		margin-left: 2.5rem;
		margin-bottom: 0.8rem;
		margin-top: 0.8rem;
		font-size: 1.25rem;
	}

	/* Mobiles */
	@media (max-width: 640px) {
		margin-left: 3rem;
		margin-bottom: 0.5rem;
		margin-top: 0.5rem;
		font-size: 1.25rem;
	}

`;

export default SwapTitle;